var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4392 8.88839L0.639019 26.6889C0.22699 27.1006 -1.79208e-07 27.6502 -1.53593e-07 28.2362C-1.27977e-07 28.8222 0.22699 29.3718 0.639019 29.7835L1.94958 31.0944C2.80355 31.9474 4.19151 31.9474 5.04419 31.0944L19.9917 16.1469L34.9558 31.111C35.3678 31.5227 35.9171 31.75 36.5028 31.75C37.0891 31.75 37.6384 31.5227 38.0508 31.111L39.361 29.8001C39.773 29.3881 40 28.8388 40 28.2528C40 27.6668 39.773 27.1172 39.361 26.7055L21.5445 8.88839C21.1312 8.47571 20.5793 8.24905 19.9927 8.25035C19.4037 8.24905 18.8522 8.47571 18.4392 8.88839Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.0108a754ce6f3093299221ed1301fcfc.svg";
export { ForwardRef as ReactComponent };